import React from 'react'
import LoadingImg from 'IMAGES/loading.svg'

const loadingStyle = {
    zIndex: 10000,
    textAlign:'center',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'rgba(0,0,0,0.2)'
}

const loadingDivStyle = {
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.9)',
    padding: 20,
    width: 400,
    margin: '250px auto 0px'
}

export default function LoadingScreen({ text }){
    return (
        <div style={loadingStyle} id="loadingScreen">
            <div style={loadingDivStyle}>
                <img src={LoadingImg} alt="loading indicator"/><br />
                <h4 style={{fontWeight:'bold'}}>{text}</h4>
            </div>
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/components/shared/LoadingScreen.js